/**
 * `invitation` actions
 *
 */
export const REQUEST_INVITE_REQUEST = 'invitation/REQUEST_INVITE_REQUEST';
export const REQUEST_INVITE_SUCCESS = 'invitation/REQUEST_INVITE_SUCCESS';
export const REQUEST_INVITE_FAILURE = 'invitation/REQUEST_INVITE_FAILURE';
